import { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Typography,
  Button,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import OpenInNewRounded from "@mui/icons-material/OpenInNewRounded";
import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

export default function Navbar({
  drawerWidth = 240,
  onDrawerToggle,
  logout,
  setActiveComponent,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { currentUser } = useAuth();
  const name = currentUser?.name?.firstName || currentUser?.username;

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = () => {
    logout();
    handleMenuClose();
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
        backgroundColor: "rgba(29, 25, 21, 0.86)",
        backdropFilter: "blur(14px)",
        borderBottom: "1px solid rgba(234, 215, 167, 0.12)",
        color: "#f5efe3",
        zIndex: theme.zIndex.drawer + 1,
        py: 0.05
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: { xs: 3, sm: 3 },
        }}
      >
        {/* Left Section — Drawer Toggle + Greeting */}
        <Box display="flex" alignItems="center" gap={2} sx={{ minWidth: 0 }}>
          {isMobile && (
            <IconButton
              color="inherit"
              edge="start"
              onClick={onDrawerToggle}
              sx={{ mr: 1 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{
                color: "#ead7a7",
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: ".16em",
                textTransform: "uppercase",
              }}
            >
              MJMarry dashboard
            </Typography>
            <Typography
              noWrap
              sx={{
                fontFamily: '"Playfair Display", Georgia, serif',
                fontSize: { xs: 16, sm: 20 },
                lineHeight: 1.3,
              }}
            >
              {name ? `Assalamu alaikum, ${name}` : "Assalamu alaikum"}
            </Typography>
          </Box>
        </Box>

        {/* Right Section — Site Link + Account Menu */}
        <Box display="flex" alignItems="center" gap={1}>
          {!isMobile && (
            <Button
              component={RouterLink}
              to="/"
              variant="outlined"
              size="small"
              endIcon={<OpenInNewRounded fontSize="small" />}
              sx={{ borderColor: "rgba(234, 215, 167, 0.3)", color: "#ead7a7" }}
            >
              View site
            </Button>
          )}
          <IconButton
            color="inherit"
            onClick={handleMenuOpen}
            aria-label="Account menu"
            sx={{
              ml: 1,
              "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
            }}
          >
            <AccountCircle fontSize="large" />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            PaperProps={{
              sx: {
                backgroundColor: "#252018",
                color: "white",
                mt: 1,
                minWidth: 150,
              },
            }}
          >
            <MenuItem
              onClick={() => {
                setActiveComponent("profile");
                handleMenuClose();
              }}
            >
              Edit Profile
            </MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
